function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.0474 5.91412L13.0184 3.90372L22.0455 13.0097C22.0455 13.0097 22.4002 14.2711 18.4583 18.2525C14.5163 22.2338 13.0184 21.9973 13.0184 21.9973L3.91243 13.0097L8.32745 8.63408L8.32744 3.82488C8.32744 3.82488 9.23409 -0.0776844 13.0184 0.0011784C16.8026 0.0800412 17.5122 3.90372 17.5122 3.90372V6.34774L15.7383 4.61327C15.7383 4.61327 15.8566 2.36633 13.0972 1.85388C10.9291 1.77504 10.1802 3.90372 10.1802 3.90372V11.6694C10.1802 11.6694 10.3378 12.5366 11.2051 12.7337C12.1511 12.9487 12.6242 12.3395 12.6242 12.3395C12.6242 12.3395 13.3337 11.5511 12.5848 10.5656C11.9146 9.93492 10.9713 10.3028 11.0474 10.1714V5.91412Z",
  fill: "#121212"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M2.80832 12.8913L6.39551 9.26465C6.39551 9.26465 2.5718 10.329 1.11328 13.4825C-0.345248 16.6361 0.0489483 19.3167 0.0489483 19.3167C0.0489483 19.3167 0.482564 20.2813 1.46805 20.2233C2.80832 20.1445 2.80832 19.0013 2.80832 19.0013V12.8913Z",
  fill: "#121212"
});

function SvgPaint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaint);
export default __webpack_public_path__ + "static/media/Paint.887d80c5.svg";
export { ForwardRef as ReactComponent };